import { Box, Stack, Typography } from "@mui/material";

export default function KeyValueText(props: { title: string; value: string }) {
    return (
        <Box>
            <Stack direction="row" spacing={1}>
                <Typography fontSize="small" color="primary">
                    {props.title}
                </Typography>

                <Typography fontSize="small" color="text.secondary">
                    {props.value}
                </Typography>
            </Stack>
        </Box>
    );
}
